export default __webpack_public_path__ + "static/media/arrows-horizontal.ec4b6d4f.svg";